import React from 'react'

import { CookieConsentModal } from '../CookieConsentModal/CookieConsentModal.jsx'
export function OneTrust() {
  if (window.ONETRUST_ALTERNATIVE) {
    return <CookieConsentModal asButton={true} />
  }
  return (
    <div className="u-sizeConstrained u-margin5gu">
      {/* OneTrust Cookies Settings button start --> */}
      <button
        id="ot-sdk-btn"
        className="ot-sdk-show-settings onetrust-page"
        data-analytics="onetrust-cta-personal-data-btn"
      >
        Do Not Sell or Share My Personal Data
      </button>
      {/* OneTrust Cookies Settings button end --> */}
    </div>
  )
}
